// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input:checked~span[data-v-4bcae96d]:nth-of-type(2){opacity:1!important}.label[data-v-4bcae96d] a{color:#4372c8}.label[data-v-4bcae96d] a:hover{color:#eb6e08}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
